// 32 Global Luxury Hotel Partners with Ultra-HD logos served from logo.dev
// SIZE=512 PNG format — resolution-independent and crisp on retina displays.
// Grouped conceptually: Indian heritage → International chains → Regional luxury

const LOGO_TOKEN = 'pk_X-1ZO13GSgeOoUrIuJ6GMQ';
const logoUrl = (domain) =>
  `https://img.logo.dev/${domain}?token=${LOGO_TOKEN}&size=512&format=png&retina=true`;

export const hotelPartners = [
  // ─── Indian Luxury ───
  { name: 'Taj Hotels', domain: 'tajhotels.com', region: 'India' },
  { name: 'Oberoi Hotels & Resorts', domain: 'oberoihotels.com', region: 'India' },
  { name: 'ITC Hotels', domain: 'itchotels.com', region: 'India' },
  { name: 'The Leela Palaces', domain: 'theleela.com', region: 'India' },
  { name: 'The Lalit', domain: 'thelalit.com', region: 'India' },
  { name: 'The Park Hotels', domain: 'theparkhotels.com', region: 'India' },
  { name: 'Roseate Hotels', domain: 'roseatehotels.com', region: 'India' },
  { name: 'Aurika Hotels', domain: 'aurikahotels.com', region: 'India' },
  { name: 'CGH Earth', domain: 'cghearth.com', region: 'India' },
  { name: 'GRT Hotels', domain: 'grthotels.com', region: 'India' },

  // ─── Marriott Collection ───
  { name: 'JW Marriott', domain: 'jwmarriott.com', region: 'Global' },
  { name: 'The Ritz-Carlton', domain: 'ritzcarlton.com', region: 'Global' },
  { name: 'St. Regis', domain: 'stregis.com', region: 'Global' },
  { name: 'W Hotels', domain: 'whotels.com', region: 'Global' },
  { name: 'Marriott Hotels', domain: 'marriott.com', region: 'Global' },

  // ─── Hyatt Collection ───
  { name: 'Grand Hyatt', domain: 'hyatt.com', region: 'Global' },
  { name: 'Park Hyatt', domain: 'hyatt.com', region: 'Global' },
  { name: 'Andaz', domain: 'andaz.com', region: 'Global' },
  { name: 'Hyatt Regency', domain: 'hyatt.com', region: 'Global' },

  // ─── Hilton Collection ───
  { name: 'Hilton', domain: 'hilton.com', region: 'Global' },
  { name: 'Conrad', domain: 'conradhotels.com', region: 'Global' },
  { name: 'Waldorf Astoria', domain: 'waldorfastoria.com', region: 'Global' },

  // ─── Accor Collection ───
  { name: 'Sofitel', domain: 'sofitel.com', region: 'Global' },
  { name: 'Fairmont', domain: 'fairmont.com', region: 'Global' },
  { name: 'Raffles', domain: 'raffles.com', region: 'Global' },
  { name: 'Pullman', domain: 'pullmanhotels.com', region: 'Global' },

  // ─── Radisson Collection ───
  { name: 'Radisson Blu', domain: 'radissonblu.com', region: 'Global' },
  { name: 'Radisson Collection', domain: 'radissoncollection.com', region: 'Global' },

  // ─── IHG Collection ───
  { name: 'InterContinental', domain: 'intercontinental.com', region: 'Global' },
  { name: 'Crowne Plaza', domain: 'crowneplaza.com', region: 'Global' },

  // ─── Independent Luxury ───
  { name: 'Four Seasons', domain: 'fourseasons.com', region: 'Global' },
  { name: 'Shangri-La', domain: 'shangri-la.com', region: 'Global' },
].map((p) => ({ ...p, logo: logoUrl(p.domain) }));
